<template>
    <div>
        <div class="page-title">Add Quick Link</div>
         <div class="page-box">
        <quickLinkFrom :ruleForm="ruleForm"></quickLinkFrom>
        <el-button  type="warning"> Submit </el-button>
        </div>
    </div>
</template>

<script>
    import quickLinkFrom from './components/quickLinkFrom.vue'
    export default {
        components:{quickLinkFrom},
        data() {
            return {
                ruleForm: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
            }
        },
        
    }
</script>

<style lang="scss" scoped>

</style>